module.exports = __webpack_public_path__ + "static/media/whiteLogo.df87e8ee.png";